import { render, staticRenderFns } from "./contentPlayDeeplink.vue?vue&type=template&id=2bf698b2"
import script from "./contentPlayDeeplink.vue?vue&type=script&lang=js"
export * from "./contentPlayDeeplink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports